import React from 'react';
import AdminElectricalStylePricingEditor from './AdminElectricalStylePricingEditor';

const SERVICES = {
  200: { name: 'Ceiling Installation' },
  201: { name: 'Drylining' },
  202: { name: 'Feature Walls' },
  203: { name: 'Flooring' },
  204: { name: 'Painting & Decorating' },
  205: { name: 'Plastering' },
  206: { name: 'Rendering' },
  207: { name: 'Tiling' },
  208: { name: 'Wallpapering' },
};

const AdminFinishingInteriorsPricingRules = ({ isTabMode = false }) => (
  <AdminElectricalStylePricingEditor
    services={SERVICES}
    title="Finishing & Interiors Pricing Rules"
    description="Manage pricing for 9 finishing and interiors services"
  />
);

export default AdminFinishingInteriorsPricingRules;
